import React, { useEffect, useState } from "react";
import { BasicRow, CombinedInvoiceData, DatabaseInvoiceData } from "./ReportDisplayTypes";
import "./ReportDisplay.css"
import { Modal, Table } from "react-bootstrap";

interface RevenueSidebySideDisplay{
    Cols: string[]
    ReportData: BasicRow[]
    DatabaseData: DatabaseInvoiceData[]
    cashCols: string[]
    CashReport: BasicRow[]
    month: number
    year: number
    Mismatch: boolean
}

function RevenueSidebySideDisplay(props:RevenueSidebySideDisplay){
    //Table data
    const [combinedData, setCombinedData] = useState<CombinedInvoiceData[]>([])

    useEffect(() => {
        //indexes for the cash data
        var cashIndex = props.cashCols.indexOf("Num")+1
        var cashAmount = props.cashCols.indexOf("Paid Amount")+1
        var cashDate = props.cashCols.indexOf("Date")+1
        //indexes for the accrual data 
        var index = props.Cols.indexOf("Num")+1
        var amountIndex = props.Cols.indexOf("Amount")+1
        var dateIndex = props.Cols.indexOf("Date")+1

        //loop through the data and add that data to the combined data list
        var data = props.ReportData
        var combined = [] as CombinedInvoiceData[]
        data.forEach(i => {
            //get the invoice amount, id, and date
            var invoiceID = i.ColData?.find(x => x.colID === index)?.value ?? ""
            var invoiceAmount = i.ColData?.find(x => x.colID === amountIndex)?.value ?? "-99999"
            var invoiceDate = i.ColData?.find(x => x.colID===dateIndex)?.value ?? ""

            //look for a matching set in the database data
            var duplicate = props.DatabaseData.find(x => x.InvoiceNumber.toUpperCase()===invoiceID && x.InvoiceAmount === Number(invoiceAmount))
            var miscDuplicate = props.DatabaseData.find(x => x.InvoiceNumber.toUpperCase()===invoiceID && x.MiscAmount === Number(invoiceAmount))
            //create the row object
            var object = {
                InvoiceNumber: invoiceID,
                InvoiceAmount: Number(invoiceAmount),
                InvoiceDate: invoiceDate,
                DataInvoiceNumber: "",
                DataInvoiceAmount: -99999,
                MiscAmount: -99999,
                DataInvoiceDate: ""
            } as CombinedInvoiceData 
            //if there is a match using the InvoiceAmount set the object properties to match those values
            if(duplicate){
                object.DataInvoiceAmount = duplicate.InvoiceAmount
                object.DataInvoiceDate = duplicate.GLDate.split("T")[0]
                object.DataInvoiceNumber = duplicate.InvoiceNumber
            }
            // if there is a match using the MiscAmount set the object properties to match those values
            else if(miscDuplicate){
                object.MiscAmount = miscDuplicate.MiscAmount
                object.DataInvoiceDate = miscDuplicate.GLDate.split("T")[0]
                object.DataInvoiceNumber = miscDuplicate.InvoiceNumber
            }
            //push row object to combined data
            combined.push(object)
        })
        //loop through the data and add that data to the combined data list
        var cash = props.CashReport
        cash.forEach(i => {
            //get the invoice amount, id, and date
            var invoiceID = i.ColData?.find(x => x.colID === cashIndex)?.value ?? ""
            var invoiceAmount = i.ColData?.find(x => x.colID === cashAmount)?.value ?? "-99999"
            var invoiceDate = i.ColData?.find(x => x.colID===cashDate)?.value ?? ""

            //look for a matching set in the database data
            var duplicate = props.DatabaseData.find(x => x.InvoiceNumber.toUpperCase()===invoiceID && x.InvoiceAmount === Number(invoiceAmount))
            var miscDuplicate = props.DatabaseData.find(x => x.InvoiceNumber.toUpperCase()===invoiceID && x.MiscAmount === Number(invoiceAmount))
            //create the row object
            var object = {
                InvoiceNumber: invoiceID,
                InvoiceAmount: Number(invoiceAmount),
                InvoiceDate: invoiceDate,
                DataInvoiceNumber: "",
                DataInvoiceAmount: -99999,
                MiscAmount: -99999,
                DataInvoiceDate: ""
            } as CombinedInvoiceData 
            //if there is a match using the InvoiceAmount set the object properties to match those values
            if(duplicate){
                object.DataInvoiceAmount = duplicate.InvoiceAmount
                object.DataInvoiceDate = duplicate.GLDate.split("T")[0]
                object.DataInvoiceNumber = duplicate.InvoiceNumber
            }
            // if there is a match using the MiscAmount set the object properties to match those values
            else if(miscDuplicate){
                object.MiscAmount = miscDuplicate.MiscAmount
                object.DataInvoiceDate = miscDuplicate.GLDate.split("T")[0]
                object.DataInvoiceNumber = miscDuplicate.InvoiceNumber
            }
            //to ask: should cash invoices be included in the side by side
            //combined.push(object)
        })
        //Now filter all entries in the database data that do not have a InvoiceAmount match in cash or accrual
        var list = props.DatabaseData.filter((a) => {
            var reportInvoice = data.find(x =>{
                var invoiceID = x.ColData?.find(y => y.colID === index)?.value ?? ""
                var ammount = x.ColData?.find(y => y.colID === amountIndex)?.value ?? -99999
                return invoiceID ===a.InvoiceNumber.toUpperCase() && Number(ammount)===a.InvoiceAmount
            })
            var cashInvoice = cash.find(x => {
                var invoiceID = x.ColData?.find(y => y.colID === cashIndex)?.value ?? ""
                var ammount = x.ColData?.find(y => y.colID === cashAmount)?.value ?? -99999
                return invoiceID ===a.InvoiceNumber.toUpperCase() && Number(ammount)===a.InvoiceAmount
            })
            if(reportInvoice !== undefined){
                return false
            }
            if(cashInvoice !== undefined){
                //return false
            }
            return true
        })
        //for each entrie in list add a row object to the combined data list
        list.forEach(x => {           
            combined.push({
                DataInvoiceAmount: x.InvoiceAmount,
                DataInvoiceNumber: x.InvoiceNumber,
                DataInvoiceDate: x.GLDate.split("T")[0],
                InvoiceNumber: "",
                InvoiceAmount: -99999,
                InvoiceDate: "",
                MiscAmount: -99999
            })
        })
        //Now filter all entries in the database data that do not have a MiscAmount match in cash or accrual
        var miscList = props.DatabaseData.filter((a) => {
            if(a.MiscAmount === null || a.MiscAmount === 0){
                return false
            }
            var reportInvoice = data.find(x =>{
                var invoiceID = x.ColData?.find(y => y.colID === index)?.value ?? ""
                var ammount = x.ColData?.find(y => y.colID === amountIndex)?.value ?? -99999
                return invoiceID ===a.InvoiceNumber.toUpperCase() && Number(ammount)===a.MiscAmount
            })
            var cashInvoice = cash.find(x => {
                var invoiceID = x.ColData?.find(y => y.colID === cashIndex)?.value ?? ""
                var ammount = x.ColData?.find(y => y.colID === cashAmount)?.value ?? -99999
                return invoiceID ===a.InvoiceNumber.toUpperCase() && Number(ammount)===a.MiscAmount
            })
            if(reportInvoice !== undefined){
                return false
            }
            if(cashInvoice !== undefined){
                //return false
            }
            return true
        })
        //for each entrie in list add a row object to the combined data list
        miscList.forEach(x => {
            combined.push({
                DataInvoiceAmount: -99999,
                DataInvoiceNumber: x.InvoiceNumber,
                DataInvoiceDate: x.GLDate.split("T")[0],
                InvoiceNumber: "",
                InvoiceAmount: -99999,
                InvoiceDate: "",
                MiscAmount: x.MiscAmount
            })
        })
        //sort all the data by their invoice number
        combined.sort((a,b) => {
            var idA = a.InvoiceNumber
            var idB = b.InvoiceNumber
            if(a.InvoiceNumber===""){
                idA = a.DataInvoiceNumber
            }
            if(b.InvoiceNumber ===""){
                idB = b.DataInvoiceNumber
            }
            if(idA>idB){
                return 1
            }
            else if(idB>idA){
                return -1
            }
            else{
                return 0
            }
        })
        setCombinedData(combined)
    }, [])
    return(
        <div className="ReportDisplayQB">
            <div className="Side-By-SideTitles">
                <div className="tableTitleQB">
                    <b>Quickbooks</b>
                </div>
                <div className="tableTitleQB">
                    <b>IP</b>
                </div>
            </div>
            <div className="ReportTableQB ReportSidebySideQB">
                <Table>
                    <thead>
                        <tr>
                            <th>
                                Invoice Number
                            </th>
                            <th>
                                Invoice Amount
                            </th>
                            <th>
                                Invoice Date
                            </th>
                            <th>
                                Invoice Number
                            </th>
                            <th>
                                Invoice Amount
                            </th>
                            <th>
                                Misc Amount
                            </th>
                            <th>
                                Invoice Date
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            combinedData?.map((x, index) => {
                                var style = {}
                                if(x.InvoiceNumber === ""){
                                    style = {backgroundColor:"#AA1D20", color: "white"}
                                }
                                else if(x.DataInvoiceNumber === ""){
                                    style = {backgroundColor:"#eed202"}
                                }
                                else{
                                    if(props.Mismatch){
                                        return null
                                    }
                                    style = {backgroundColor:"#2E8B60", color: "white"}
                                }
                                return(
                                    <tr key={index} style={style}>
                                        <td>
                                            {x.InvoiceNumber}
                                        </td>
                                        <td>
                                            {x.InvoiceAmount===-99999? "":x.InvoiceAmount}
                                        </td>
                                        <td>
                                            {x.InvoiceDate}
                                        </td>
                                        <td>
                                            {x.DataInvoiceNumber}
                                        </td>
                                        <td>
                                            {x.DataInvoiceAmount===-99999?"":x.DataInvoiceAmount}
                                        </td>
                                        <td>
                                            {x.MiscAmount===-99999?"":x.MiscAmount}
                                        </td>
                                        <td>
                                            {x.DataInvoiceDate}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default RevenueSidebySideDisplay